import React from 'react';
import SanitizedRender from '@reverbdotcom/commons/src/components/sanitized_render';
import { RecommendedRadio } from './recommended_radio';
import { CoreBumpRecommendationListingCard } from '../../schemas/rql';
import { BumpDescription } from './bump_description';
import { ListingPreview } from './listing_preview';
import { MParticleEventName } from '@reverbdotcom/commons/src/elog/mparticle_types';
import I18n from 'i18n-js';
import { useViewTracking } from '@reverbdotcom/commons/src/use_tracking';
import { formatBid } from './bump_helpers';
import { RCAlertBox } from '@reverbdotcom/commons/src/rc/RCAlertBox';

const COMPONENT_NAME = 'BumpModalContainer';

interface Props {
  bid: number;
  handleBidChange: (bid: number) => void;
  listing: CoreBumpRecommendationListingCard.Fragment;
  recommendationAmount: number;
  selectedBid: number;
  successMessage: string;
  failMessage: string;
  updateBid: (
    bid: number,
    bumpRecommendationAmount: number,
    listing: CoreBumpRecommendationListingCard.Fragment,
    refetch: () => void,
  ) => void;
  refetch: () => void;
  onRequestClose?: Function;
}

export function BumpModal(props: Props) {
  const [showCustomWarning, setShowCustomWarning] = React.useState(false);
  const [updatedBid, setUpdatedBid] = React.useState(false);

  const mParticleViewData = {
    componentName: COMPONENT_NAME,
    eventName: MParticleEventName.ViewedBumpSlider,
    listing: props.listing,
    startingBumpRatePercent: formatBid(props.bid),
    bumpRecommendationPercent: props.recommendationAmount,
  };

  useViewTracking(mParticleViewData, true);

  const setBump = () => {
    props.updateBid(
      props.selectedBid,
      props.recommendationAmount,
      props.listing,
      props.refetch,
    );

    setUpdatedBid(true);
  };

  React.useEffect(() => {
    if (props.successMessage && updatedBid) {
      props.onRequestClose?.();
    }
  });

  function Messages() {
    return (
      <>
        {props.failMessage &&
          <div className="scaling-mb-2">
            <RCAlertBox type="error">
              <SanitizedRender html={props.failMessage} />
            </RCAlertBox>
          </div>
        }
        {props.successMessage &&
          <div className="scaling-mb-2">
            <RCAlertBox type="success">
              {props.successMessage}
            </RCAlertBox>
          </div>
        }
      </>
    );
  }

  return (
    <>
      <Messages />
      <div className="scaling-mb-2">
        <ListingPreview
          listing={props.listing}
        />
      </div>
      <div className="scaling-mb-2">
        <BumpDescription
          listing={props.listing}
        />
      </div>
      <>
        <div className="scaling-mt-3">
          <RecommendedRadio
            handleBidChange={props.handleBidChange}
            listing={props.listing}
            recommendationAmount={props.recommendationAmount}
            selectedBid={props.selectedBid}
            updateBid={props.updateBid}
            refetch={props.refetch}
            showCustomWarning={showCustomWarning}
            setShowCustomWarning={setShowCustomWarning}
          />
        </div>

        <div className="align-right scaling-mt-1">
          <button
            type="button"
            className="button button--primary size-90 weight-bold"
            disabled={(showCustomWarning)}
            onClick={
              () => {
                setBump();
              }
            }
          >
            {I18n.t('discovery.bumpModalV2.modal.save')}
          </button>
        </div>
      </>
    </>
  );
}
